// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__JUkp1","large":"styles_large__yhw_7"};